module.exports = __webpack_public_path__ + "media/images/logos/lever-3eec5b1f21a7dd99bc3758cef560ce28.png";